<template>
  <section class="module dt-relative lyw">
    <h3 v-if="playlist.length > 0">
      本片播放源（共{{ playlist.length }}个）
    </h3>
    <h3 v-else>
      本片播放源（暂无）
    </h3>
    <ul
      v-if="playlist.length > 0"
      class="dt-relative-wrap"
    >
      <li
        v-for="(value, index) in playlist"
        :key="index"
      >
        <a
          :href="value.playUrl"
          :uigs="'moviepy_out_list_video_' + index"
          :uigsparams="`play_type=video&play_url=${encodeURIComponent(value.ourl)}&play_site=${value.domain}`"
        >
          <div class="dt-relative-item-img">
            <Image-1
              :src="value.picurl"
              alt=""
            />
            <span
              v-if="value.duration && value.duration !== 0"
              class="tag-play"
            >{{
              formatDuration(value.duration)
            }}</span>
          </div>
          <div class="dt-relative-item-info simple">
            <p>
              <img
                v-if="value.icon"
                class="icon-sp"
                :src="item.imgpath + '/logo/' + value.icon"
                alt=""
              >
              {{ value.siteName }}
            </p>
          </div>
        </a>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapState } from 'vuex';

import Image from './Image.vue';

export default {
  components: {
    'Image-1': Image,
  },
  computed: {
    ...mapState('detail', ['itemData']),
    playlist() {
      const playlist = this.itemData.playList;
      if (playlist && playlist.length > 0) {
        return playlist;
      }
      return [];
    },
    item() {
      return this.itemData;
    },
  },
  methods: {
    formatDuration(duration) {
      if (duration === '' || typeof duration === undefined) {
        return '';
      }
      if (duration.toString().indexOf(':') > -1) {
        return duration;
      }
      const duarationNum = parseInt(duration, 10);
      let durationStr = '';
      const hour = Math.floor(duarationNum / 3600);
      const min = Math.floor((duarationNum - hour * 3600) / 60);
      const sec = duarationNum - hour * 3600 - min * 60;

      if (sec < 0 || hour < 0 || min < 0) {
        return durationStr;
      }

      if (!(min === 0 && sec === 0 && hour === 0)) {
        if (hour !== 0) {
          durationStr = `${hour}:`;
        }
        if (min === 0) {
          durationStr += '00:';
        } else {
          if (min < 10) durationStr += `0${min}:`;
          else durationStr += `${min}:`;
        }
        if (sec === 0) {
          durationStr += '00';
        } else if (sec > 0) {
          if (sec < 10) durationStr += `0${sec}`;
          else durationStr = durationStr + sec;
        }
      }
      return durationStr;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.dt-relative.lyw {
  margin-bottom: 13px;
  //padding-top: 12px;
}

.dt-relative-item-info.simple p {
  @include line-clip(1);
  font-size: 13px;
  vertical-align: middle;
}

.icon-sp {
  width: 13px;
  height: 13px;
  margin-right: 4px;
  vertical-align: -2px;
}
</style>
